/**
 * La pastille de compteur — sur l'entrée « Messagerie » du panneau de navigation.
 *
 * Cachée à zéro : une pastille à « 0 » dirait moins que rien, elle dirait
 * « regardez, il ne se passe rien » là où l'absence de pastille ne dit rien du
 * tout — la même logique que #86 sur le zéro plausible.
 *
 * Plafonnée à 99+ : au-delà, le chiffre exact n'aide personne à décider s'il faut
 * ouvrir la messagerie maintenant, et trois chiffres casseraient la ligne.
 */
import { t } from '../i18n/langue';

interface PastilleNonLusProps {
    nombre: number;
}

export default function PastilleNonLus({ nombre }: PastilleNonLusProps) {
    if (nombre <= 0) return null;

    const affiche = nombre > 99 ? '99+' : String(nombre);
    const texteAccessible = t('messagerie.nonLues', { n: nombre });

    return (
        <span className="ml-auto flex h-6 min-w-[1.5rem] shrink-0 items-center justify-center rounded-full bg-main-color px-1.5 text-xs font-semibold text-white">
            <span aria-hidden="true">{affiche}</span>
            <span className="sr-only">{texteAccessible}</span>
        </span>
    );
}
